import React, { useEffect, useMemo } from 'react';
import { chatState, useProjectStore, userStore } from '../../zustand';
import { useRoomManager } from '../../hooks/useRoomManager';
import { isEmpty } from 'underscore';
import { useChatManager } from '../../hooks/useChatManager';

const CustomerWrapper = ({ children }) => {
    const { fetchProjects } = useProjectStore()
    const user = userStore((state) => state.user)
    const { getUserRoom } = useRoomManager()
    const setRoomId = chatState((state) => state.setRoomId);
    const setRoomInfo = chatState((state) => state.setRoomInfo);
    const setUnread = chatState((state) => state.setUnread);
    const setProjectUnread = chatState((state) => state.setProjectUnread);
    const { unread, projectUnread } = useChatManager()

    useEffect(() => {
        fetchProjects(1, 1)
    }, []);


    useEffect(() => {        
        if (unread?.messages) {
            setUnread(unread.messages.length);
        }
        if (projectUnread?.messages) {
            setProjectUnread(projectUnread.messages.length);
        }
    }, [unread, projectUnread]);

    useMemo(() => {
        const init = async () => {
            if (user && 'id' in user && !isEmpty(user.id)) {
                let room = await getUserRoom(user.id)
                if (room) {
                    setRoomId(room.id)
                    setRoomInfo(room)
                }
            }
        }
        init()
    }, [user])

    return (
        <>
            {children}

        </>
    );
};

export default CustomerWrapper;